import { Rise } from "@/components/site/Reveal";
import { AmazonButton } from "@/components/site/CTA";
import { ASSETS, AMAZON_RLAL } from "@/lib/site";

export const WhereStarted = () => {
  return (
    <section
      data-testid="where-started-section"
      className="relative bg-ink py-28 sm:py-36 border-t border-bone/10"
    >
      <div className="mx-auto max-w-[1200px] px-6 sm:px-10">
        <Rise className="mb-14">
          <p className="font-sans text-[0.7rem] uppercase tracking-[0.4em] text-bone-muted">
            Where it started
          </p>
        </Rise>

        <div className="grid grid-cols-1 sm:grid-cols-12 gap-10 sm:gap-8 items-center">
          {/* intentionally smaller cover */}
          <Rise className="sm:col-span-4">
            <img
              src={ASSETS.rlalCover}
              alt="Ride Like a Lady: A Beginner’s Guide to Motorcycling cover"
              loading="lazy"
              className="w-[46vw] max-w-[220px] sm:max-w-[240px] h-auto cover-shadow mx-auto sm:mx-0"
              data-testid="rlal-cover"
            />
          </Rise>

          <Rise delay={0.1} className="sm:col-span-8">
            <h3 className="font-serif uppercase tracking-tight text-bone text-3xl sm:text-4xl lg:text-5xl leading-[0.95]">
              Ride Like a Lady
            </h3>
            <p className="mt-3 font-serif italic text-lg text-bone-soft">
              A Beginner’s Guide to Motorcycling
            </p>
            <div className="mt-6 max-w-xl space-y-4 font-sans text-sm sm:text-base leading-relaxed text-bone-muted">
              <p>
                Before Women Who Don’t Sit Still, there was Ride Like a Lady.
              </p>
              <p>
                A beginner’s guide to getting on the motorcycle, getting out of
                your own head, and actually riding.
              </p>
            </div>
            <div className="mt-8">
              <AmazonButton
                href={AMAZON_RLAL}
                variant="outline"
                size="sm"
                testId="rlal-buy-button"
              >
                Explore Ride Like a Lady
              </AmazonButton>
            </div>
          </Rise>
        </div>
      </div>
    </section>
  );
};
